const STORAGE_KEY = "smarttt_live_training_ctx_v1";
const AUTO_ENTER_SUPPRESS_KEY = "smarttt_coach_lt_autoenter_suppressed_v1";

export function writeLiveTrainingContext({ ts_id, gr_id, windowEndMs }) {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ts_id,
        gr_id,
        windowEndMs,
        leftAtMs: Date.now(),
      })
    );
  } catch {
    // ignore quota errors
  }
}

export function readLiveTrainingContext() {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearLiveTrainingContext() {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/**
 * Coach left Live Training for Home/Dashboard on purpose.
 * Blocks useCoachLiveTrainingAutoEnter until they re-enter via FAB / session card.
 */
export function markCoachLeftLiveTraining(tsId = null) {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(
      AUTO_ENTER_SUPPRESS_KEY,
      JSON.stringify({
        ts_id: tsId != null ? String(tsId) : null,
        atMs: Date.now(),
      })
    );
  } catch {
    // ignore
  }
}

export function clearCoachLiveTrainingAutoEnterSuppress() {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.removeItem(AUTO_ENTER_SUPPRESS_KEY);
  } catch {
    // ignore
  }
}

export function isCoachLiveTrainingAutoEnterSuppressed(tsId = null) {
  if (typeof sessionStorage === "undefined") return false;
  try {
    const raw = sessionStorage.getItem(AUTO_ENTER_SUPPRESS_KEY);
    if (!raw) return false;
    const data = JSON.parse(raw);
    if (!data || typeof data !== "object") return true;
    if (tsId == null || data.ts_id == null) return true;
    return String(data.ts_id) === String(tsId);
  } catch {
    return false;
  }
}
